module.exports = __webpack_public_path__ + "static/IBMPlexSans-Bold-88468edcbb512ffa28964dacf404bd0f.woff2";